<template>
  <div class="component-view-container">
    <section class="view-header-top">
      <div class="container-fluid bp-container">
        <div
          class="breadcrumbs d-none d-lg-flex pt-6"
          v-if="breadcrumbs.length"
        >
          <router-link :to="{ name: 'home' }" class="text-secondary fs-12">
            Início
          </router-link>
          <i class="icon-angle-right text-secondary mx-3" />
          <div
            v-for="(route, i) in breadcrumbs"
            :key="i"
            class="d-flex align-items-center"
          >
            <div v-if="breadcrumbs[i + 1]" class="d-flex align-items-center">
              <router-link
                :to="{ name: route.link, params: route.params }"
                class="text-secondary fs-12"
              >
                {{ route.title }}
              </router-link>
              <i class="icon-angle-right text-secondary mx-3" />
            </div>
            <span v-else class="text-active fs-14">{{ route.title }}</span>
          </div>
        </div>

        <div
          class="mb-5 row justify-content-between align-items-center d-lg-none"
        >
          <div class="col-3 col-lg-6">
            <button
              class="btn text-secondary p-0 d-flex align-items-center font-weight-normal"
              @click="$router.go(-1)"
              v-if="breadcrumbs.length"
            >
              <i class="icon-angle-left fs-20 mr-3" />
              Voltar
            </button>
          </div>
          <slot name="responsive-header-button" />
        </div>
        <section class="view-header" v-if="header">
          <slot name="header">
            <div class="row justify-content-between">
              <div class="col-lg-6">
                <div class="view-title">
                  {{ title }}
                </div>
                <div
                  class="view-subtitle"
                  v-if="subtitle"
                  v-html="subtitle"
                ></div>
              </div>

              <div
                class="col-lg-6 d-flex justify-content-lg-end align-items-end"
              >
                <slot name="header-button" />
              </div>
            </div>
          </slot>
        </section>
      </div>
    </section>

    <section class="view-content">
      <div class="container-fluid bp-container">
        <div v-if="loading" class="text-center my-9">
          <b-spinner variant="primary" />
        </div>
        <div class="d-flex flex-column h-100" v-else>
          <section class="view-content-header" v-if="contentHeader">
            <slot name="content-header">
              <div class="row justify-content-between">
                <div class="col-lg-6">
                  <div class="view-title">
                    {{ title }}
                  </div>
                  <div class="view-subtitle" v-if="subtitle">
                    {{ subtitle }}
                  </div>
                </div>

                <div
                  class="col-lg-6 d-flex justify-content-end align-items-center"
                  v-if="headerButton"
                >
                  <button
                    class="btn d-none d-lg-flex btn-40"
                    :class="buttonClass"
                    @click="$emit('click-button')"
                  >
                    {{ buttonText }}
                  </button>
                  <button
                    class="btn d-lg-none btn-block my-3 btn-40"
                    :class="buttonClass"
                    @click="$emit('click-button')"
                  >
                    {{ buttonText }}
                  </button>
                </div>
              </div>
            </slot>
          </section>
          <slot />
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  props: {
    header: {
      type: Boolean,
      default: false
    },
    breadcrumbs: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: "Title"
    },
    subtitle: {
      type: String,
      default: ""
    },
    headerButton: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      default: "ButtonText"
    },
    buttonClass: {
      type: String,
      default: "btn-outline-secondary"
    },
    contentHeader: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="scss" scoped>
.component-view-container {
  border-top: 1px solid rgba(255, 255, 255, 0.24);
  min-height: calc(100vh - 58px);
  display: flex;
  flex-direction: column;
  .breadcrumbs {
    display: flex;
    align-items: center;
    margin-bottom: 32px;

    a {
      text-decoration: none;
      font-size: 12px;
    }
    span {
      font-size: 14px;
    }
  }

  .view-header-top {
    background: var(--l-elevation-8);
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.08);
  }
  .view-content-header {
    padding-top: 24px;
  }
  .view-header {
    padding-bottom: 24px;
  }

  .view-content {
    background: var(--l-elevation-16);
    box-shadow: 0px 0px 32px rgba(0, 0, 0, 0.08);
    flex: 1;
    display: flex;
  }

  .bp-container {
    max-width: 1536px;
  }

  .text-active {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    color: #57586be0;
  }
  ::v-deep.form-group {
    .el-input__inner {
      height: 50px;
      min-height: 50px;
      border-color: rgba(184, 186, 204, 0.86);
      &::placeholder {
        color: rgba(119, 120, 142, 0.87);
      }
    }
    .el-select__caret {
      color: #666666;
    }
  }
}
</style>
